// Uptime exibido no card (modo detalhado), a partir de host.uptime /
// host.hasSysUpTime (backend) ou, em último caso, dos itens do host (itensData).
// - uptimeString: já convertido pelo backend ("X dias Y horas Z minutos")
// - sysUpTime: valor bruto, sem conversão → "Uptime não mapeado"
// - nenhum dos dois → null (não exibe)

export const UPTIME_NAO_MAPEADO = "Uptime não mapeado";

// "12 dias 3 horas 20 minutos" → "12 dias"; "0 dias 5 horas 2 minutos" → "5 horas".
// Mostra só a maior unidade não zerada; formato desconhecido volta como veio.
const UNIDADES = [
  { re: /(\d+)\s*dias?\b/i, um: "dia", varios: "dias" },
  { re: /(\d+)\s*horas?\b/i, um: "hora", varios: "horas" },
  { re: /(\d+)\s*minutos?\b/i, um: "minuto", varios: "minutos" },
];

export function uptimeResumido(texto) {
  const partes = UNIDADES.map((u) => ({
    ...u,
    n: Number(texto?.match(u.re)?.[1]),
  }));
  if (partes.every((p) => Number.isNaN(p.n))) return texto;
  const maior = partes.find((p) => p.n > 0) ?? partes[partes.length - 1];
  const n = Number.isNaN(maior.n) ? 0 : maior.n;
  return `${n} ${n === 1 ? maior.um : maior.varios}`;
}

const mapeado = (completo) => ({
  valor: uptimeResumido(completo),
  completo,
  mapeado: true,
});

// chaves podem vir com parâmetros, ex.: sysUpTime[...] / uptimeString[...]
const keyIs = (item, nome) =>
  item?.key_?.toLowerCase()?.split("[")[0] === nome.toLowerCase();

export function uptimeDoHost(hosts) {
  let temSysUpTime = false;
  for (const host of hosts ?? []) {
    // campos enviados sempre pelo backend (independe de "itens do host")
    const valor = host?.uptime?.trim();
    if (valor) return mapeado(valor);
    if (host?.hasSysUpTime) temSysUpTime = true;

    // fallback: backend antigo, só com o item selecionado em itensData
    const itens = host?.itensData ?? [];
    const valorItem = itens
      .find((i) => keyIs(i, "uptimeString"))
      ?.lastvalue?.trim();
    if (valorItem) return mapeado(valorItem);
    if (itens.some((i) => keyIs(i, "sysUpTime"))) temSysUpTime = true;
  }
  return temSysUpTime ? { valor: UPTIME_NAO_MAPEADO, mapeado: false } : null;
}
